/**
 * Filters Google suggestions where Persian «یا» is glued to the next token
 * after a questions-phase probe like "آرزو یا".
 */
export function isGluedYaSuggestion(
  suggestion: string,
  parentQuery: string,
  seed: string,
): boolean {
  const trimmedParent = parentQuery.trim();
  if (!trimmedParent.endsWith(' یا')) {
    return false;
  }

  const trimmedSuggestion = suggestion.trim();
  const trimmedSeed = seed.trim();
  if (!trimmedSeed || !trimmedSuggestion.startsWith(trimmedSeed)) {
    return false;
  }

  const remainder = trimmedSuggestion.slice(trimmedSeed.length).trim();
  if (!remainder) {
    return false;
  }
  if (remainder === 'یا' || remainder.startsWith('یا ')) {
    return false;
  }

  return remainder.charAt(0) === 'ی';
}
